import { render, staticRenderFns } from "./EventLiveDonationItemList.vue?vue&type=template&id=bb633196&scoped=true&"
import script from "./EventLiveDonationItemList.vue?vue&type=script&lang=js&"
export * from "./EventLiveDonationItemList.vue?vue&type=script&lang=js&"
import style0 from "./EventLiveDonationItemList.vue?vue&type=style&index=0&id=bb633196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb633196",
  null
  
)

export default component.exports